import BaseLayout from 'layouts';
import { IRewardLayout } from '../../interfaces/components/layout.interface';
import { NextPageWithLayout } from '../../pages/page';

const FolderDetailLayout: NextPageWithLayout<
  IRewardLayout & {
    disableGutters?: boolean /* If true, the left and right padding is removed. */;
  }
> = ({ children, disableGutters = false }) => {
  return (
    <BaseLayout>
      <article className="flex flex-col sm:block h-full w-full sm:pt-0">
        <div className={`w-full pb-10 ${disableGutters ? '' : 'px-3 sm:px-5'}`}>
          {children}
        </div>
      </article>
    </BaseLayout>
  );
};

export default FolderDetailLayout;
